<template>
  <section class="container content-padding">
    <template v-if="inboxes === null">
      <loader/>
    </template>
    <template v-else>
      <template v-if="inboxes.length === 0 && queryData.page === 0">
        <notification classname="alert-info" body="message.no_data"/>
      </template>
      <template v-else>
        <h2>{{ $t('message.inbox.inbox') }}</h2>
        <div class="card panel-inbox">
          <div class="card-body">
            <ul class="list-unstyled">
              <inbox v-for="inbox in inboxes" v-bind:key="inbox.id" :inbox="inbox"/>
            </ul>
          </div>
        </div>
        <div class="text-center">
          <button class="button -cyan"
                  :disabled="state.isFetching"
                  @click="fetchInboxes"
                  v-if="state.isMore"> {{ $t(isLoadMore) }}
          </button>
        </div>
      </template>
    </template>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Inbox from './Inbox'
  import Loader from '../loader/Loader'
  import Notification from '../partials/Notification'

  export default {
    components: {
      Inbox,
      Loader,
      Notification
    },
    data () {
      return {
        queryData: {
          page: 0,
          user_id: null
        }
      }
    },
    computed: {
      ...mapGetters({
        inboxes: 'inbox/getInboxes',
        isLoadMore: 'inbox/isLoadMore',
        state: 'inbox/getState',
        user: 'auth/getUser'
      })
    },
    methods: {
      fetchInboxes () {
        this.queryData.page++
        this.$store.dispatch('inbox/LOAD_INBOX_LIST', this.queryData)
      }
    },
    mounted () {
      this.queryData.user_id = this.user.id
      this.$store.dispatch('inbox/LOAD_INBOX_LIST', this.queryData)
      this.$store.commit('notification/SET_NEW_INBOX', false)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/inbox/Index.vue